import * as Yup from "yup";

export const AddGoalInitialState = {
  team: "",
  time: "",
  player: "",
  description: "",
};

export const AddGoalValidationSchema = Yup.object({
  team: Yup.string().required("Este campo es requerido"),
  time: Yup.string().required("Este campo es requerido"),
  player: Yup.string().required("Este campo es requerido"),
  description: Yup.string().required("Este campo es requerido"),
});
